import React, { Component } from "react";
import Header from "./header";
import SidePanel from "./sidePanel";
import Dashboard from "./dashboard";
import Contract from "./Contract";
import Matrix from "./matrix";
import { ethers } from 'ethers';
import getWallet from '../../services/wallet';
import withWrapper from '../../helpers/withWrapper';
import getContract from "../../services/contract";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Flip, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class DashboardLayout extends Component {
  constructor(props) {
    super(props);
    if(props.router.params.id > 0) {
      this.state.userId = props.router.params.id;
    }
    else {
      this.state.userId = 1;
    }
    // this.notify("Global Reward has no longer been accumulated, All new 10% distribution has been moving to BUSO treasury, But you can still claim");
  }
  state = {
    view: 'dashboard',
    isViewMode: false,
    signer: null,
    isSideBarOpen: false,
  };

  handleSetUserId = (id) => {
    this.setState({userId: id});
  }

  connectWallet = async () => {
    const wallet = await getWallet();
    if(!wallet.isReadOnly) {
      this.setState({ signer: wallet.signer });
      console.log("Wallet Connected");
    }
  }

  handleWalletConnected = async (contract) => {
    this.setState({ signer: contract.signer });
  }

  handleConnectWallet = () => {
    this.connectWallet();
  }

  handleDashboardClick = () => {
    this.props.router.navigate('/dashboard/' + this.state.userId);
    toast.dismiss()
    this.sideBarToggle()
  }

  handlePoolClick = () => {
    this.props.router.navigate('/global-pools/' + this.state.userId);
    toast.dismiss()
    this.sideBarToggle()
  }

  handleContractClick = () => {
    this.props.router.navigate('/contracts');
    toast.dismiss()
    this.sideBarToggle()
  }

  sideBarToggle = () => {
    this.setState({isSideBarOpen: !this.state.isSideBarOpen})
  }

  handleNavigateToRegister = (userId) => {
    this.props.router.navigate('/join?refId=' + userId);
  }

  handleToastError = (message) => {
    this.notify(message);
  }

  handleNavigateToLogin = () => {
    this.props.router.navigate('/login');
  }

  handleSetUserId = (id) => {
    this.setState({userId: id});
  }

  handleSlotClick = (level) => {
    this.props.router.navigate('/dashboard/' + this.state.userId + '/' + level);
    this.setState({ level, view: 'matrix' });
  }

  notify = (message) => toast.error(message, 
    {position: toast.POSITION.BOTTOM_LEFT, delay: "4000", style: {zIndex: "2"}, transition: Flip, autoClose: 4000 });
 
  render() {
    return (
      <div id="__next1">
        <ToastContainer position="bottom-right" theme="colored" autoClose={1000} />
        <div className="relative flex bg-main-bg items-center justify-center min-h-screen min-w-full overflow-hidden">
          <Header
            onConnectWallet={this.handleConnectWallet}
            signer={this.state.signer}
            sideBarToggle={this.sideBarToggle}
            onDisconnect={this.handleNavigateToLogin}
          />
          <div className="flex w-full h-full justify-center max-w-desktop-full">
            <SidePanel onDashboardClick={this.handleDashboardClick} 
              id={this.state.userId}
              onPoolsClick={this.handlePoolClick} sideBarOpened={this.state.isSideBarOpen}
              onContractsClick={this.handleContractClick}
            />
            <Routes>
              <Route path="dashboard/:id" element={<Dashboard 
                navigateToRegister={this.handleNavigateToRegister}
                onSetUserId={(id) => this.handleSetUserId(id)}
                onSlotClick={this.handleSlotClick}
                onError={(message) => this.handleToastError(message)}
                isViewMode={this.state.isViewMode}
                userId={this.state.userId}
                onWalletConnected={this.handleWalletConnected}
              />} />
              <Route path="dashboard/:id/:level" element={<Matrix 
                onSetUserId={(id) => this.handleSetUserId(id)}
                router={this.props.router}
                level={this.state.level}
                userId={this.state.userId}
                idsOnLevel={this.state.idsOnLevel}
              />} />

            {/* <Route path="contracts" element={<Contract />} /> */}
            
            </Routes>
          </div>
        </div>
      </div>
    );
  }
}

export default withWrapper(DashboardLayout);
